define(["exports", "react"], function (_exports, _react) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.ChatIcon = ChatIcon;
  _react = _interopRequireDefault(_react);

  function ChatIcon(_ref) {
    var url = _ref.url,
        role = _ref.role;
    return /*#__PURE__*/_react.default.createElement("div", {
      id: "chat-mount-point",
      url: url,
      role: role,
      origin: "epartner-ui"
    });
  }
});